import RankingStatCalculatorBase from "./RankingStatCalculatorBase.js";

class MultiRankingStatCalculator extends RankingStatCalculatorBase {
    constructor(supportedParams, rankingStatCaseVerifier, skipCache) {
        super(supportedParams, rankingStatCaseVerifier);

        this.statsPerRef = [];
        this.skipCache = !!skipCache;
    }

    /**
     * Calculates given statistical parameter
     * @param {object} parameter - a parameter to calculate, object from Enum PitchingRankingStats, BattingRankingStats or GeneralRankingStats
     * @param {ResultsSlice} slice - result slice with scope
     * @param {object} session - session object, @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/session-v2.json
     * @param {object} league - league object, @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/league.json
     * @returns {RankingStat|null} RankingStat instance or null when calculation wasn't possible
     */
    calculateStat(parameter, slice, session, league) {
        const cached = this.skipCache 
            ? null
            : this.statsPerRef.find(spr =>
                // note - this is reference based mainly
                (spr.session === session || session.id === spr.session.id)
                && (spr.league === league || spr.league.id === league.id)
                && spr.slice === slice
                && spr.stats 
                // && spr.stats.hasOwnProperty(parameter.key)
            )
        ;

        if (cached) {
            return cached.stats.hasOwnProperty(parameter.key) ? cached.stats[parameter.key] : null;
        }

        const calculated = {
            session, league, slice,
            stats: this.forceCalculate(slice, session, league) || {}
        };

        if (!this.skipCache) {
            this.statsPerRef.push(calculated);
        }

        if (calculated && calculated.stats && calculated.stats.hasOwnProperty(parameter.key)) {
            return calculated.stats[parameter.key];
        }

        return null;
    }

    /**
     * Calculates given statistical parameter when it is not avaialble in cache
     * @param {ResultsSlice} slice - result slice with scope
     * @param {object} session - session object, @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/session-v2.json
     * @param {object} league - league object, @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/league.json
     * @returns {object} object with keys equal to ranking stat parameter name and RankingStat instance as value
     */
    forceCalculate(slice, session, league) {
        throw new Error('forceCalculate not implemented');
    }

    clearCache() {
        this.this.statsPerRef = [];
    }
}

export default MultiRankingStatCalculator;